import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

const categoryCounts: Record<string, number> = {};
articles.forEach((a) => {
  categoryCounts[a.category] = (categoryCounts[a.category] || 0) + 1;
});

const categoryMeta: Record<string, { description: string; icon: string }> = {
  celebrity: { description: "明星八卦、恋情曝光、婚变内幕", icon: "ri-star-line" },
  influencer: { description: "网红翻车、带货内幕、人设崩塌", icon: "ri-user-smile-line" },
  entertainment: { description: "综艺黑幕、影视圈潜规则", icon: "ri-movie-2-line" },
  social: { description: "社会热点、行业乱象、深度调查", icon: "ri-flashlight-line" },
  expose: { description: "独家爆料、第一手内幕消息", icon: "ri-eye-line" },
};

export default function CategoryGrid() {
  const entries = Object.entries(categoryMeta);

  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="mb-8">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
              <i className="ri-grid-line text-secondary-500 mr-2"></i>
              分类浏览
            </h2>
            <p className="text-sm text-foreground-600 mt-1">按分类快速找到你感兴趣的黑料</p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
            {entries.map(([slug, meta]) => (
              <Link
                key={slug}
                to={`/category/${slug}`}
                className="group flex flex-col items-center p-6 bg-background-50 border border-background-200 rounded-xl hover:border-primary-300 hover:bg-background-100 transition-all duration-300 cursor-pointer"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-100 text-foreground-700 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300 mb-3">
                  <i className={`${meta.icon} text-xl`}></i>
                </div>
                <h3 className="text-foreground-950 font-semibold text-sm mb-1 whitespace-nowrap">
                  {slug === "celebrity" ? "明星黑料" : slug === "influencer" ? "网红内幕" : slug === "entertainment" ? "娱乐圈" : slug === "social" ? "社会热点" : "独家曝光"}
                </h3>
                <p className="text-foreground-500 text-xs text-center leading-relaxed line-clamp-2 mb-2">
                  {meta.description}
                </p>
                <span className="text-xs text-primary-500 font-medium whitespace-nowrap">
                  {categoryCounts[slug] || 0} 篇文章
                </span>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}